<template>
    <div class="contents-xr">
        <a-scene>
            <!-- shadow test -->
            <a-entity light="type:directional; castShadow:true;" position="1 1 1"></a-entity>

            <!-- freezer model test -->
            <a-assets>
                <a-asset-item 
                    id="glbtestmodel"
                    src="/xr-files/MAW-107-A01-FreezerSTL.STL.glb"
                    >
                </a-asset-item>
            </a-assets>
            <a-entity 
                id="glbtest"
                gltf-model='gltf-model="url(/xr-files/MAW-107-A01-FreezerSTL.STL.glb)"'
                position="0 0 -2.5"
                scale="0.0013 0.0013 0.0013"
                rotation="90 0 0"
                >
            </a-entity>
            <a-entity 
                id="glbtest2"
                gltf-model='gltf-model="url(/xr-files/VCU2.glb)"'
                position="2.5 0 -2.5"
                scale="0.0013 0.0013 0.0013"
                rotation="90dd 0 0"
                >
            </a-entity>            

            <!-- data panel -->
            <a-entity 
            id="textArea" 
            position="-0.27 1.59807 -1.058" 
            rotation="-10 0 0" 
            geometry="primitive: plane; width: 0.5; height: 0.348" 
            material="color: #414da4; transparent: true; opacity: 0.7; side: double" 
            text="wrapCount: 30; opacity: 0.9; color: #ffffff; value: ERROR - NO DATA; xOffset: 0.015; yOffset: -0.09" 
            text-display=""
            >
            </a-entity>

            <!-- back wall -->
            <a-entity 
            geometry="primitive: plane; height: 5; width: 10" 
            position="1.02088 1 -4.0029" 
            material="color: #ffffff; side: double"
            >
            </a-entity>

            <!-- left wall -->
            <a-entity 
            geometry="primitive: plane; height: 5; width: 8" 
            position="-4 1 -3.0029"
            rotation="0 90 0"         
            material="color: #ffffff; transparent: false; opacity: 1; side: double" 
            >
            </a-entity>

            <!-- right wall -->
            <a-entity 
            geometry="primitive: plane; height: 5; width: 8" 
            position="5.91 1 -3.0029"
            rotation="0 90 0"         
            material="color: #ffffff; transparent: false; opacity: 1; side: double" 
            >
            </a-entity>

            <!-- wall image -->
            <a-assets>
            <img 
                id="logo" 
                src="../../assets/images/LifeChain_Logo.jpg"
                >
            </a-assets>

            <!-- wall image plane -->
            <a-plane 
            src="#logo" 
            height="0.2505" 
            width="1.24" 
            rotation="" 
            position="-3.1627 3.17538 -4" 
            material="" 
            geometry="height: 0.251"
            >
            </a-plane>

            <!-- ref: https://github.com/supermedium/aframe-environment-component -->
            <a-entity environment></a-entity> 
        </a-scene>

    </div>
</template>

<script>


export default {
    name: "XR",
    data() {
        return {
            test: "test",
        };
    },    
    mounted() {
        // Display core vue app element
        const appElement = document.getElementById('app');
        appElement.style.display = 'block';

        let script = document.createElement('script');
        script.setAttribute('src', '/xr-files/aframe-environment-component.min.js');
        document.head.appendChild(script);
    },
    watch: {

    },
    created() {
    },    
    methods: {

    },
};
</script>

<style>
  div.contents-xr {
    position: absolute; 
    height: 100%; 
    width: 100%;
  }

</style>
